import React from 'react'
import {
    useState,
    useEffect
} from 'react';
import {
    Page,
    Stack,
    ResourceList,
    ResourceItem,
    Layout,
    Card,
    SkeletonBodyText,
    Badge,
    Button,
    Icon,
    Link
} from '@shopify/polaris';
import { apiFetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";
import {
    RefreshMajor
} from '@shopify/polaris-icons';

function BulkOperationViewPage(props) {

    const { params } = props.match;
    const [loading, setLoading] = useState(true);
    const [loadingTasks, setLoadingTasks] = useState(true);
    const [id] = useState(params.id);
    const [tasks, setTasks] = useState([]);
    const [bulkOperationInfo, setBulkOperationInfo] = useState(null);
    const shopOrigin = Cookies.get("shopOrigin");

    useEffect(() => {
        if (id == null) {
            return;
        }

        fetchBulkOperationData(id);

    }, [id]);

    useEffect(() => {

        if (bulkOperationInfo == null) {
            return;
        }

        fetchTasks(id);

    }, [id, bulkOperationInfo]);

    const fetchBulkOperationData = (id) => {
        apiFetch(`api/bulkOperations/${id}/info`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => {
                setBulkOperationInfo(data);
                setLoading(false);
            });
    }

    const fetchTasks = (id) => {

        setLoadingTasks(true);

        apiFetch(`api/bulkOperations/${id}/tasks`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => {
                setTasks(data);
                setLoadingTasks(false);
            });
    }

    const renderTaskItem = (item) => {
        const { description, id, status } = item;

        var resourceType = "Resource";
        var resourceLegacyId = "Link";
        var resourceUrl = "";

        if (description.resourceId.startsWith("gid://shopify/Product/")) {
            resourceType = "Product";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Product/", "");
            resourceUrl = `https://${shopOrigin}/admin/products/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/Customer/")) {
            resourceType = "Customer";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Customer/", "");
            resourceUrl = `https://${shopOrigin}/admin/customers/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/Order/")) {
            resourceType = "Order";
            resourceLegacyId = description.resourceId.replace("gid://shopify/Order/", "");
            resourceUrl = `https://${shopOrigin}/admin/orders/${resourceLegacyId}`;
        }

        if (description.resourceId.startsWith("gid://shopify/ProductVariant/")) {
            resourceType = "Product Variant";
            resourceLegacyId = description.resourceId.replace("gid://shopify/ProductVariant/", "");
            resourceUrl = `https://${shopOrigin}/admin/variants/${resourceLegacyId}`;
        }

        return (
            <ResourceItem id={id} url={null} onClick={null}>
                <Stack>
                    <Stack.Item>
                        {status === "Pending" && <div>
                            <Badge status="warning">Pending</Badge>
                        </div>}
                        {status === "Error" && <div>
                            <Badge status="critical">Error</Badge>
                        </div>}
                        {status === "Completed" && <div>
                            <Badge status="success">Completed</Badge>
                        </div>}
                    </Stack.Item>
                    <Stack.Item>
                        <Badge status="info">{description.action}</Badge>
                    </Stack.Item>
                    <Stack.Item>
                        {description.actionObject}
                    </Stack.Item>
                    <Stack.Item>
                        {description.link}
                    </Stack.Item>
                    <Stack.Item>
                        <Badge status="new">{resourceType}</Badge>
                    </Stack.Item>
                    <Stack.Item>
                        <Link url={resourceUrl} external={true}>{resourceLegacyId}</Link>
                    </Stack.Item>
                </Stack>
            </ResourceItem >
        );
    }

    const handleRefresh = () => {
        fetchTasks(id);
    }

    if (loading || bulkOperationInfo == null)
        return <SkeletonBodyText lines="20" />;

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Bulk Operations</title>
            </Helmet>
            <Page
                title={"Bulk Operation: " + bulkOperationInfo.description}
                breadcrumbs={[{ content: 'Operations', url: '/operations' }]}
            >
                <Layout fullWidth>
                    <Layout.Section>
                        <Card title="Tasks"
                            actions={[{
                                content: <Button onClick={handleRefresh} outline size="medium" icon={<Icon source={RefreshMajor} />}></Button>
                            }]}>
                            <Card.Section>
                                <p>{`${tasks.length} tasks were triggered by this operation`}</p>
                            </Card.Section>
                            <ResourceList
                                loading={loadingTasks}
                                resourceName={{ singular: 'task', plural: 'tasks' }}
                                items={tasks}
                                renderItem={renderTaskItem}
                            />
                        </Card>
                    </Layout.Section>
                </Layout>
            </Page>
        </div>
    );
}

export default BulkOperationViewPage